// extracted by mini-css-extract-plugin
module.exports = {"form":"RecuperarSenha_form__3T9WL","logTitulo":"RecuperarSenha_logTitulo__1qXNt","msgLogin":"RecuperarSenha_msgLogin__2nb0I"};